export const passwordRegexp: RegExp = /^(?=.*[a-z])(?=.*[!@#$%&*^()\-+|,\.;:'"])(?=.*\d).{8,}$/i;
